import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Main(props: {}) {
    return <div className="d-flex flex-column w-100 align-items-stretch text-left">
        <h1>Get Started</h1>
        <div className="mb-3">Install the Dubmon bot on your Nginx server and view analytics online. Updates daily!</div>
        <h2>Automated installation</h2>
        <div className="alert alert-info">
            <h4 className="alert-heading">Prerequisities</h4>
            This automated installation expects your server to be running <strong>systemd</strong> and a standard install of <strong>Nginx</strong>. There must
            exist a user that has read access to Nginx configuration and access logs that the bot can run as, by default this is <strong> www-data</strong> but 
            the installation will let you specify another user.
        </div>
        <h4>1. Create a bot access key</h4>
        <div className="mb-3">A key lets the bot upload statistics to the Dubmon backend. Go to the <Link to="/bots">bots page</Link> and create a new bot key.</div>
        
        <h4>2. Run the install script on your server</h4>
        <div>The script will ask you for your bot key and download and install the bot binary and start it as a systemd service.</div>
        <div className="pl-5 code mt-2 mb-2">curl https://dl.dubmon.com/install.sh | sudo sh</div>
        <div className="mb-3">The dubmon-bot binary will be installed into /usr/lib/dubmon. The systemd service gets started automatically and you can control the service
        with sudo systemctl status/start/stop/restart dubmon-bot</div>

        <h4>3. See your activity</h4>
        <div className="mb-3">Go to the Gateway and Activity tabs to see what the bot has reported (might need to reload a few times if lots of data). You can 
        run <strong> sudo systemctl status dubmon-bot </strong> to check the status of the bot if data does not appear.</div>

        <h2>Customization and manual install</h2>
        <h4>My main Nginx conf is not located at /etc/nginx/nginx.conf</h4>
        <div className="mb-3">Run the install. Add the line "Environment=DUBMON_NGINX_CONF_DIR=/your/nginx dir/" to the /lib/systemd/system/dubmon-bot.service file, replacing the path 
        with the path to the <em> directory </em> of your nginx.conf file. Restart the service with sudo systemctl restart dubmon-bot</div>
        <h4>I'm not running systemd</h4>
        <div>Download the dubmon-bot binary and install it as a service with whatever service management system you use, running as a user that
        can read Nginx config and access logs. Specify the bot key in an environment parameter called DUBMON_BOT_KEY for the dubmon-bot process.
        </div>
    </div>;
  }

  export default Main;